export const useChatDrawerState = () =>
  useState<boolean>('app_drawer', () => false)
